import { ExOption, OptionType } from '@/proto/field';

import { IMetricData, SubLogType } from '@/service/rum';

/**
 * 在请求token的时候，为了简化处理逻辑，filters里面的字段用来给后台解析
 * filters外面的字段用来回显表单，为了避免和后台字段有冲突（后台有些老代码会同时读filters外面和里面的字段）,
 * 回显的统一加上了standard_前缀
 */
export enum MiniProgramFieldKey {
  MpPlatform='standard_mp_platform',
  IsError = 'standard_is_err',
  Method = 'standard_method',
  URL = 'standard_url',
  // 日志正文
  Msg = 'standard_msg',
  Level = 'standard_level',
  ErrorMsg = 'standard_error_msg',
  Feature='feature',
  SessionId = 'standard_session_id',
  DeviceId = 'standard_qimei',
  API = 'standard_url',
  NetType = 'standard_net_type',
  Platform = 'standard_platform',
  Operator = 'standard_isp',
  Brand = 'standard_brand',
  Model = 'standard_model',
  Browser = 'standard_browser',
  Region = 'standard_region',
  SdkVersion = 'standard_sdk_version',
  ProductVersion = 'standard_product_version',
  BizVersion='standard_biz_version',
  FrameworkVersion='standard_framework_version',
  AppVersion = 'standard_app_version',
  Os = 'standard_os',
  Ext1 = 'standard_ext1',
  Ext2 = 'standard_ext2',
  Ext3 = 'standard_ext3',
  Domain = 'standard_domain',
  Status = 'standard_status',
  Ret = 'standard_ret',
  Type = 'standard_type',
  AccountId = 'standard_account_id',
  From = 'standard_from',
  Strategy = 'standard_page_load_strategy',
  DurationCost = 'standard_duration_cost',
  TransferSize = 'standard_transfer_size',
  HttpVersion = 'standard_http_version',
  Name = 'standard_name',
  Duration = 'standard_duration',
  AbTags = 'standard_ab_tags',
}

export enum MiniProgramFieldFilterKey {
  MpPlatform='mp_platform',
  TransferSize = 'transfer_size',
  Method = 'method',
  HttpVersion = 'http_version',
  IsError = 'is_err',
  URL = 'url',
  Msg = 'msg',
  Level = 'level',
  ErrorMsg = 'error_msg',
  SessionId = 'session_id',
  DeviceId = 'qimei',
  API = 'url',
  NetType = 'net_type',
  Platform = 'platform',
  Operator = 'isp',
  Brand = 'brand',
  Model = 'model',
  Browser = 'browser',
  Region = 'region',
  SdkVersion = 'sdk_version',
  ProductVersion='product_version',
  FrameworkVersion='framework_version',
  BizVersion='biz_version',
  AppVersion = 'app_version',
  QiMei='qimei',
  Os = 'os',
  Ext1 = 'ext1',
  Ext2 = 'ext2',
  Ext3 = 'ext3',
  Domain = 'domain',
  Status = 'status',
  Ret = 'ret',
  Type = 'type',
  AccountId = 'account_id',
  From = 'from',
  Feature='feature',
  Strategy = 'page_load_strategy',
  DurationCost = 'duration_cost',
  Name = 'name',
  Duration = 'duration',
  ElapsedTime = 'elapsed_time',
  AbTags = 'ab_tags',
}

export enum MiniProgramLogType {
// LogTypeLog log 日志集合
  LogTypeLog = 'log',
  // LogTypePV pv 日志集合
  LogTypePV = 'pv',
  // LogTypeEvent 自定义事件日志集合
  LogTypeEvent = 'event',
  // LogTypeCustom 自定义测速日志集合
  LogTypeCustom = 'custom',
  // LogTypeHippyPerformance 测速 hippy 性能指标集合
  LogTypeLaunchPerformance = 'launch',
  LogTypeRouteChangePerformance = 'routeChange',
  LogTypeSetDataPerformance = 'setData',
  // LogTypeStatic 静态资源测速指标集合
  LogTypeStatic = 'static',
  // LogTypeFetch 接口测速指标集合
  LogTypeFetch = 'fetch',
  // LogTypeNativeLoadEvent 页面加载事件
  LogTypeNativeLoadEvent = 'native_load_event',
}

export enum MiniProgramLogLevelNum {
  ERROR = 200002,
  SDK_ERROR = 2048,
  PROMISE_ERROR = 8,
  AJAX_ERROR = 16,
  SCRIPT_ERROR = 200004,
  WEBSOCKET_ERROR = 32768,
  IMAGE_ERROR = 64,
  CSS_ERROR = 128,
  MEDIA_ERROR = 512,
  RET_ERROR = 1024,
  NATIVE_ENGINE_ERROR = 200001,
  PAGE_NOT_FOUND_ERROR = 16384,
}

export const FIELD_DEFAULT_OPERATOR = {

};

export const MINIPROGRAM_LOG_ERROR = [
  MiniProgramLogLevelNum.ERROR,
  MiniProgramLogLevelNum.SDK_ERROR,
  MiniProgramLogLevelNum.PROMISE_ERROR,
  MiniProgramLogLevelNum.AJAX_ERROR,
  MiniProgramLogLevelNum.SCRIPT_ERROR,
  MiniProgramLogLevelNum.WEBSOCKET_ERROR,
  MiniProgramLogLevelNum.IMAGE_ERROR,
  MiniProgramLogLevelNum.CSS_ERROR,
  MiniProgramLogLevelNum.MEDIA_ERROR,
  MiniProgramLogLevelNum.RET_ERROR,
  MiniProgramLogLevelNum.NATIVE_ENGINE_ERROR,
  MiniProgramLogLevelNum.PAGE_NOT_FOUND_ERROR,
];

export enum MiniProgramPerfStrategy {
  CacheFetchLatest = 'CacheFetchLatest',
  NetworkFetchLatest = 'NetworkFetchLatest',
}

export const MINIPROGRAM_PERF_STRATEGY_OPTIONS = [
  {
    value: MiniProgramPerfStrategy.CacheFetchLatest,
    label: '实时加载远端最新版本',
  },
  {
    value: MiniProgramPerfStrategy.NetworkFetchLatest,
    label: '加载本地最新版本',
  },
];

// 后台filters接收的value只能是string
export enum MiniProgramErrorLevel {
  CrossError = '200002',
  PromiseError = '8',
  AjaxError = '16',
  PageNotFoundError = '16384',
}

export const MINIPROGRAM_ERROR_LEVEL_OPTIONS = [
  {
    value: MiniProgramErrorLevel.CrossError,
    label: 'JS执行错误',
  },
  {
    value: MiniProgramErrorLevel.PromiseError,
    label: 'Promise错误',
  },
  {
    value: MiniProgramErrorLevel.AjaxError,
    label: 'Ajax请求异常',
  },
  {
    value: MiniProgramErrorLevel.PageNotFoundError,
    label: '小程序页面不存在',
  },
];

export const MP_PLATFORM_OPTIONS = [
  {
    value: 'wx',
    label: '微信',
  },
  {
    value: 'tt',
    label: '抖音',
  },
  {
    value: 'my',
    label: '支付宝',
  },
  {
    value: 'swan',
    label: '百度',
  },
];

export enum MiniProgramLogLevel {
  WHITE = '1',
  INFO = '2',
  ERROR = '200002',
  PROMISE_ERROR = '8',
  AJAX_ERROR = '16',
  JS_ERROR='32',
  IMAGE_ERROR = '64',
  CSS_ERROR = '128',
  CONSOLE_ERROR ='256',
  AV_ERROR ='512',
  RET_ERROR = '1024',
  AEGIS_REPOPT = '2048',
  PV = '4096',
  EVENT ='8192',
  PAGE_ERROR = '16384',
  WEBSOCKET_ERROR = '32768',
  JSBRIDGE_ERROR='65536',
  NATIVE_ENGINE_ERROR = '131072',
  ASYNC_FAILURE='131072'
}


export const MINIPROGRAM_LOG_TYPE_OPTIONS = [
  { label: '错误监控/JS执行错误', value: SubLogType.ERROR_SCRIPT },
  { label: '错误监控/Promise错误', value: SubLogType.ERROR_PROMISE },
  { label: '错误监控/页面不存在错误', value: SubLogType.ERROR_PAGE_NOT_FOUND },
  { label: '错误监控/异步组件加载失败', value: SubLogType.ERROR_LAZY_LOAD },
  { label: '错误监控/Ajax请求异常', value: SubLogType.ERROR_AJAX },
  { label: 'API监控/请求失败', value: SubLogType.API_ERROR },
  { label: 'API监控/请求成功', value: SubLogType.API_INFO },
  { label: '静态资源', value: SubLogType.ASSETS_SPEED },
  { label: '启动性能', value: SubLogType.LAUNCH_PERFORMANCE },
  { label: '页面性能', value: SubLogType.PAGE_PERFORMANCE },
  { label: '运行性能', value: SubLogType.RUNNING_PERFORMANCE },
  { label: '页面访问', value: SubLogType.PV },
  { label: '自定义事件', value: SubLogType.CUSTOM_EVENT },
  { label: '自定义测速', value: SubLogType.CUSTOM_TIME },
  { label: '用户日志/一般日志', value: SubLogType.NORMAL_INFO },
  { label: '用户日志/白名单日志', value: SubLogType.NORMAL_REPORT },
  { label: '用户日志/错误日志', value: SubLogType.NORMAL_ERROR },
  { label: 'SDK错误', value: SubLogType.SDK_ERROR },
  { label: 'Websocket错误', value: SubLogType.WEBSOCKET },
];

// 日志类型-等级 -> subType的映射关系，用于从列表跳转到日志页面
export const MINIPROGRAM_SUBTYPE_MAPPING = {

};

export const getLocalFieldMiniProgram = (fieldKey: MiniProgramFieldFilterKey) => {
  const fields: Partial<Record<MiniProgramFieldFilterKey, ExOption[]>> = {
    [MiniProgramFieldFilterKey.Strategy]: MINIPROGRAM_PERF_STRATEGY_OPTIONS,
    [MiniProgramFieldFilterKey.Level]: MINIPROGRAM_ERROR_LEVEL_OPTIONS,
  };
  return fields[fieldKey];
};

export enum MiniProgramPerfStrategy {
  Launch = 'launch',
  RouteChange = 'routeChange',
}

export const MINI_PROGRAM_PERF_STRATEGY_OPTIONS = [
  {
    value: MiniProgramPerfStrategy.Launch,
    label: '启动',
  },
  {
    value: MiniProgramPerfStrategy.RouteChange,
    label: '页面跳转',
  },
];

export enum ITimingKey {
  Duration = 'duration',
  BridgeDuration = 'bridge_duration',
  NetDuration = 'net_duration',
  DomainLookup = 'domain_lookup',
  ConnectTime = 'connect_time',
  TransferSize = 'transfer_size',
}

export const METRIC_LABEL: Record<string, string> = {
  [ITimingKey.Duration]: '资源加载耗时',
  [ITimingKey.NetDuration]: '网络耗时',
  [ITimingKey.DomainLookup]: 'DNS解析时间',
  [ITimingKey.ConnectTime]: 'TCP连接时间',
};

export const METRIC_COLOR: Record<string, string> = {
  [ITimingKey.Duration]: '#9CE5CE',
  [ITimingKey.BridgeDuration]: '#8FBCFF',
  [ITimingKey.NetDuration]: '#A3D9FF',
};

export type IMetricDataWait = IMetricData & { wait: number };

export const STATIC_COST_METRIC_OPTIONS: OptionType[] = [
  { label: METRIC_LABEL[ITimingKey.Duration], value: ITimingKey.Duration },
  { label: METRIC_LABEL[ITimingKey.NetDuration], value: ITimingKey.NetDuration },
  { label: METRIC_LABEL[ITimingKey.DomainLookup], value: ITimingKey.DomainLookup },
  { label: METRIC_LABEL[ITimingKey.ConnectTime], value: ITimingKey.ConnectTime },
];

export const RUN_TIME_METRIC_OPTIONS: OptionType[] = [
  { label: 'setData耗时', value: ITimingKey.Duration },
  { label: 'setData数据大小', value: ITimingKey.TransferSize },
];
